import gql from 'graphql-tag';

export default gql`
fragment PaymentMethodFragment on PaymentMethod {
    id
    name
    is_active
    sort
    short_description
    short_description_mpl_type
    cost
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/PaymentMethodFragment.ts